import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import flagSm from '../assets/br-sm.png';

function Navbar() {
  const { user, loading, logout } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const isActive = (path) => location.pathname === path;

  const navLinks = (
    <>
      <Link to="/" className={`block py-2 md:py-0 transition-colors focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none ${isActive('/') ? 'text-yellow-300 font-bold' : 'hover:text-yellow-300'}`} onClick={closeMenu}>
        Partidas
      </Link>
      <Link to="/scoreboard" className={`block py-2 md:py-0 transition-colors focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none ${isActive('/scoreboard') ? 'text-yellow-300 font-bold' : 'hover:text-yellow-300'}`} onClick={closeMenu}>
        Classificação
      </Link>
      {user && (
        <>
          <Link to="/predictions" className={`block py-2 md:py-0 transition-colors focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none ${isActive('/predictions') ? 'text-yellow-300 font-bold' : 'hover:text-yellow-300'}`} onClick={closeMenu}>
            Meus Palpites
          </Link>
          <Link to="/payment" className={`block py-2 md:py-0 transition-colors focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none ${isActive('/payment') ? 'text-yellow-300 font-bold' : 'hover:text-yellow-300'}`} onClick={closeMenu}>
            Pagamento
          </Link>
          <Link to="/profile" className={`block py-2 md:py-0 transition-colors focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none ${isActive('/profile') ? 'text-yellow-300 font-bold' : 'hover:text-yellow-300'}`} onClick={closeMenu}>
            Perfil
          </Link>
          <button
            onClick={() => { logout(); closeMenu(); }}
            className="block w-full text-left md:w-auto bg-red-600 hover:bg-red-700 text-white font-semibold px-3 py-2 md:py-1 rounded transition-colors focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none"
          >
            Sair
          </button>
        </>
      )}
      {!user && (
        <>
          <Link to="/login"
             className="block bg-secondary hover:bg-secondary-dark text-green-900 font-semibold px-3 py-2 rounded transition-colors text-center focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none"
             onClick={closeMenu}
          >
            Login
          </Link>
          <Link to="/register"
             className="block bg-tertiary hover:bg-tertiary-dark text-white font-semibold px-3 py-2 rounded transition-colors text-center focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none"
             onClick={closeMenu}
          >
            Cadastre-se
          </Link>
        </>
      )}
      {user && user.is_admin && (
        <Link to="/admin"
           className="block bg-purple-600 hover:bg-purple-700 text-white font-semibold px-3 py-2 rounded transition-colors text-center focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none"
           onClick={closeMenu}
        >
          Admin
        </Link>
      )}
    </>
  );

  return (
    <nav className="bg-primary text-white shadow-lg">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo/Title */}
          <Link to="/" className="flex items-center space-x-2 hover:opacity-80 transition-opacity cursor-pointer flex-shrink-0 focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none rounded">
            <img src={flagSm} alt="Bandeira do Brasil" width="28" height="20" className="rounded-sm shadow-sm" />
            <span className="text-lg md:text-xl font-bold">Bolão Copa 2026</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4">
            {loading ? (
              <div className="text-yellow-300">Carregando...</div>
            ) : (
              navLinks
            )}
          </div>

          {/* Mobile Hamburger Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-lg hover:bg-primary-dark transition-colors focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none"
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-200 ease-out motion-reduce:transition-none ${menuOpen ? 'max-h-96 mt-3 pt-3 border-t border-primary-dark' : 'max-h-0'}`}
        >
          <div className="space-y-1">
            {loading ? (
              <div className="text-yellow-300 py-2">Carregando...</div>
            ) : (
              navLinks
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
